<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">成品入库</div>
        <span style="color: red" v-if="hostcs" @click="reload()">测试服</span>
        <div style="display: flex; justify-content: space-between; align-items: center;margin-top: 10px; ">
            <div style="display: flex; align-items: center;justify-content: space-between;width: 65%;">
                <div style="font-size: 14px;">明细码: </div>
                <input id="gck_number-input" class="getgck_number-input" @keyup.enter="goGck()" ref="getIDInpot"
                    v-model="gck_number" v-on:blur="hideMessage('gck_number')" readonly autocomplete="off" />
            </div>
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
        </div>
        <!-- <div style="padding:10px 10px; height: 20%;" class="print-only" id="popupPrint" v-if="AllowP">  12.6连工说启兰不需要 寒心
            <div>
                <div class="list-data">
                    <div class="list-data-div-a">货号: {{ goods_number }}</div>
                    <div class="list-data-div-a">明细码: {{ gck_number }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">仓库: {{ ck }}</div>
                    <div class="list-data-div-a">门幅: {{ menfu }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">现存量: {{ count }}</div>
                    <div class="list-data-div-a" style="display: flex;">
                        <div style="text-align: left; font-size: 0.48rem; margin-right: 10px;">货位: </div>
                        <input class="list-data-div-a" v-model="goods" @input="changeGoods()">
                    </div>
                </div>
                <div class="list-data">
                    <div style="text-align: left; font-size: 0.48rem; margin-right: 10px;">入库数量:</div>
                    <input class="list-data-div-a" v-model="count_up" type="number" @input="changeNum()">
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">入库状态:</div>
                    :class="{'ok': i.sign === 1, 'no': i.sign === 0}"  i.sign === 1 ? 'OK' : 'NO'
                    <div :class="type === '已入库' ? 'Already' : 'Nalready'" :readonly="type == '已入库'">{{ type }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a" style="width:100%">上次入库人: {{ people }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a" style="width:100%">上次入库时间: {{ lasttime }}</div>
                </div>
            </div>
        </div> -->
        <div :style="style">
            <div class="goods-info-two-f" v-for="(i, index) in data" :key="index">
                <div style="width: 100%; text-align: right">
                    <van-icon name="cross" @click="deleteData(index)" style="margin: 5px 5px 0 0" size="22px" />
                </div>
                <div class="info-order-h">
                    <div style="width: 60%; display: flex; align-items: center">
                        <div class="right-Pandian">商品名: {{ i.goods_number }}</div>
                    </div>
                    <div style="width: 60%; display: flex">
                        <div class="right-Pandian">明细码: {{ i.gck_number }}</div>
                    </div>

                </div>
                <div class="info-order-h">
                    <div style="width: 80%; display: flex">
                        <div class="right-Pandian">规格: {{ i.size }}</div>
                    </div>
                    <!-- <div style="width: 40%; display: flex">
                        <div class="right-Pandian">货位: {{ i.goods }}</div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button" @click="go_check()">确认入库</van-button>
            <div style="margin: 0 10px; font-size: 18px;">已扫明细数：{{ allcount }}</div>
            <!-- <van-button v-if="AllowP" type="danger" class="bottom-button" @click="go_back()">撤销</van-button> -->
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import axios from 'axios';
import { Dialog } from "vant";
import { Toast } from "vant";
import moment from 'moment';
export default {
    name: "FabricInventory",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            supplier_xh: "",
            count: "",
            count_up: "",
            data: [],
            style: "",
            allcount: 0,
            gck_number: "",
            goods_number: "",
            goods: '',
            gck_numberInfo: "",
            gck_numberInfo_up: "",
            gck_number_data: "",
            username: "",
            type: "未入库",
            AllowP: false,
            nowtime: '',
            lasttime: '',
            jieliu: false,
            menfu: '',
            ck: '',
            people: '',
            buffer: '',
            checkType: false,
            audio: new Audio(require("@/assets/ww.mp3")),
            // audio2: new Audio(require("@/assets/file.mp3")),
            audio3: new Audio(require("@/assets/已在下方列表中.mp3")),
            // audio4: new Audio(require("@/assets/库存为.mp3")),
            audio5: new Audio(require("@/assets/已入库请勿重复操作.mp3")),
        };
    },
    mounted() {
        window.receiveDataFromAndroid = this.receiveDataFromAndroid;  //安卓扫一扫
        //window.addEventListener('keydown', this.handleKeydown);  // 添加全局的键盘事件监听器
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.8 + "px;overflow:scroll";
        setTimeout(() => {
            this.focus();
        }, 500);
        if (window.location.host.indexOf("test") !== -1) {
            this.hostcs = true;
        }
    },
    beforeDestroy() {// 在组件销毁时移除事件监听器，避免内存泄漏
        //window.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
        // handleKeydown(event) {
        //     // 检查是否是普通字符键（忽略特殊键，比如 Shift、Ctrl 等）
        //     if (event.key === 'Enter') {
        //         // 如果是回车键，表示扫描完成
        //         this.finishScan();
        //     }else {
        //         this.buffer += event.key;  // 将扫描到的字符添加到缓冲区
        //         Toast( '测试'+event.key)
        //     }
        // },
        // resetScanTimeout() {
        //     // 清除上一个超时定时器，重新启动一个新的定时器
        //     if (this.scanTimeout) {
        //         clearTimeout(this.scanTimeout);
        //     }
        //     this.scanTimeout = setTimeout(() => {
        //         // 如果超过一定时间没有输入，则认为扫描结束
        //         this.finishScan();
        //     }, 500);  // 设置超时为500毫秒
        // },
        // finishScan() {
        //     // 扫描结束后，将缓冲区的数据存储到扫描数据变量中
        //     this.gck_number = this.buffer;
        //     this.buffer = '';  // 清空缓冲区，准备接收下一个扫描数据
        //     console.log('fin',this.gck_number)
        //     //Toast( this.gck_number);
        //     //this.goGck();
        // },
        goGck() {
            // 输入明细码 弹出现存量
            if (this.gck_number == '' || this.gck_number == null) { Toast('请不要输入空明细码！'); return }
            var gg = this.data.filter(item => item.gck_number === this.gck_number);
            if (gg.length != 0) { Toast('该明细码已入库在下方列表中'); this.gck_number = ''; this.audio3.play(); return }
            this.get(this.APIOBJ.mxmGetGoodsorder, { gck_number: this.gck_number }).then(
                (res) => {
                    if (res.data.status == 1) {
                        if (!res.data.data) {
                            this.gck_number = '';
                            this.focus();
                            this.audio.play();
                            Toast('明细码不存在');
                        }
                        var list = {};
                        const goodsNormtype = res.data.data.goods_normtype; // 假设格式为 "宽度:200,高度:300"

                        const keyValuePairs = goodsNormtype.split(',');
                        // 创建一个对象存储键值对
                        const normObj = {};
                        keyValuePairs.forEach(pair => {
                            const [key, value] = pair.split(':'); // 用 ":" 分割键和值
                            normObj[key] = value; // 将键值存入对象
                        });

                        // 获取宽度和高度
                        const width = normObj['宽度']; // 获取宽度对应的值
                        const height = normObj['高度']; // 获取宽度对应的值
                        const cpks = normObj['成品款式']; // 获取宽度对应的值
                        list.size = "宽" + width + "/" + "高" + height + "/" + cpks;
                        list.goods_number = res.data.data.goods_name;
                        list.gck_number = this.gck_number;
                        this.data.unshift(list); //使用了倒序后 原先显示的上半部分数据 修改数量和修改货位功能 会有问题

                        this.allcount = this.data.length;
                        this.gck_number = '';
                    } else if (res.data.status == 0) {
                        Toast(res.data.msg);
                        this.gck_number = '';
                        this.audio5.play();
                        this.focus();
                    } else {
                        this.gck_number = '';
                        this.focus();
                        this.audio.play();
                        Toast('失败');
                    }
                }
            );
        },
        go_check() {
            // this.post('http://localhost/api/business/doPandian', {data:this.data}).then(
            //     (res) => {
            //     }
            // )
            if (this.checkType) {
                return
            }
            let gckNumbers = [];

            // 遍历 this.data，提取所有 gck_number 并存入数组
            this.data.forEach(item => {
                if (item.gck_number) { // 确保 gck_number 存在
                    gckNumbers.push(item.gck_number);
                }
            });

            if (gckNumbers.length === 0) {
                Toast('请先扫描明细码！');
                return; // 终止后续逻辑
            }
            // 用逗号连接所有的 gck_number
            const gckNumbersString = gckNumbers.join(',');
            this.checkType = true;
            this.get(this.APIOBJ.fpVouch, { gck_number: gckNumbersString, user_name: this.username })
                .then(res => {
                    if (res.data.status == 1) {
                        this.data = [];
                        this.count = '';
                        this.goods_number = '';
                        this.menfu = '';
                        this.gck_number = '';
                        this.ck = '';
                        this.people = '';
                        this.lasttime = '';
                        this.goods = '';
                        this.AllowP = false;
                        this.gck_number = '';
                        this.allcount = 0;
                        this.focus();
                        Toast('更新入库成功');
                        this.checkType = false;
                    } else {
                        Toast('更新失败');
                        this.checkType = false;
                    }
                })
                .catch(error => {
                    // 处理错误
                    console.error(error);
                    Toast('入库失败，数据存在问题！');
                    this.checkType = false;
                });
        },
        changeNum() {
            if (this.count_up != '') {
                this.data[this.allcount - 1].count = this.count_up;
            } else {
                this.data[this.allcount - 1].count = this.count;
            }
        },
        go_back() {
            this.get(this.APIOBJ.backPandian, { gck_number: this.gck_number }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.type = '未入库';
                        Toast('撤销入库成功')
                        this.focus();
                    } else {
                        Toast('撤销失败')
                    }
                }
            )
        },
        reload() {
            window.location.reload();
            // this.$refs.getGCKInpot.focus();
            // this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
            // setTimeout(() => {
            //   this.$refs.getGCKInpot.removeAttribute("readonly");
            // }, 200);
        },
        deleteData(index) {
            Dialog.confirm({
                message: "确定要撤销该明细库吗？",
            }).then(() => {
                this.data.splice(index, 1);

                this.allcount--
                setTimeout(() => {
                    Toast('撤销成功')
                }, 0);
            });
        },
        hideMessage(title) {
            this.$refs.getIDInpot.focus();
            // if (title === "gck_number") {
            //     if (this.gck_number === "") {
            //         this.ray = "已暂停，点击我继续扫码";
            //     }
            // }
            // if (title === "gck_number_data") {
            //     if (this.gck_number_data === "") {
            //         this.ray = "已暂停，点击我继续扫码";
            //     }
            // }
        },

        receiveDataFromAndroid(data) {   //安卓扫一扫
            this.gck_number = data;
            document.getElementById("gck_number-input").value = data;
            this.goGck();
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.gck_number === "") {
                this.focus();
                Android.scarn();//安卓扫一扫
            } else if (this.gck_number_data === "") {
                this.gck_input();
                Android.scarn();//安卓扫一扫
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.Already {
    background-color: rgb(1, 165, 1);
    color: white;
    width: 60px;
    height: 20px;
    padding-top: 2px;
    border-radius: 5px;
}

.Nalready {
    background-color: rgb(231, 82, 82);
    color: white;
    width: 60px;
    height: 20px;
    padding-top: 2px;
    border-radius: 5px;
}

.info-data {
    display: flex;
    padding: 0px 10px 10px 10px;
    align-items: center;
    justify-content: center;
}

.bottom-button-x {
    border-radius: 0.5em;
    width: 35%;
}

.list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
}

.list-data-div-a {
    //padding-right: 3px;
    text-align: left;
    font-size: 0.48rem;
    width: 50%;
}

.getgck_number-input {
    height: 25px;
    width: 4rem;
}

.goods-info-two-f {
    margin-bottom: 10px;
    background-color: #f2f2f2;
    padding-bottom: 20px;
}

.right-Pandian {
    width: 100%;
    margin: 0 15px;
    text-align: left;
    font-size: 0.48rem;
}
</style>